const user = {
    state: {
        status: 'init',
        data: null,
        withdrawStatus:0
    },
    mutations: {
        setLogin(state, data) {
            state.status = 'logined';
            state.data = data;
            return true;
        },
        setLogout(state) {
            state.status = 'logout';
            state.data = null
        },
        setWithdrawStatus(state, val) {
            state.withdrawStatus = val;
        },
    }
}

export default user
